import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheck1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "check-1" }), /* @__PURE__ */ _jsx("path", {
		d: "M23.25.749,8.158,22.308a2.2,2.2,0,0,1-3.569.059L.75,17.249",
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.5px"
	})]
});
export { SvgCheck1 as ReactComponent };
